import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarCustom from '../../common/Layout/Sidebar';
import HouseIcon from 'apollo-react-icons/House';
import MedicalCard from 'apollo-react-icons/MedicalCard';
import PresentationHierarchyLight from 'apollo-react-icons/PresentationHierarchyLight';
import StatusCheck from 'apollo-react-icons/StatusCheck';
import FileAccountPlan from 'apollo-react-icons/FileAccountPlan';
import ChevronLeft2 from 'apollo-react-icons/ChevronLeft2';
import Planner from 'apollo-react-icons/Planner';
import { useTranslation } from 'react-i18next';
import Bell from 'apollo-react-icons/Bell';
import CardView from 'apollo-react-icons/CardView';
import Hotel from 'apollo-react-icons/Hotel';
import { getCurrentUser, logout } from '../services/authService';
// import { useAuth } from '../../../Contexts/Auth';

const Sidebar = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [profileMenuProps, setProfileMenuProps] = React.useState([]);
  // const{isAuthenticated}=  useAuth()

  // // Function to toggle the language
  // const toggleLanguage = () => {
  //   const currentLang = i18n.language;
  //   const newLang = currentLang === 'en' ? 'ar' : 'en';

  //   i18n.changeLanguage(newLang);
  // };

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await getCurrentUser();
        if (!response) return;
        setProfileMenuProps(response.privileges);
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchProfileData();
  }, []);

  const checkUserRole = (roleName) => {
    return profileMenuProps?.some((pev) => pev.Privilege.Resource.name === roleName);
  };

  let menuItems = [
    {
      text: t('dashboard'),
      icon: HouseIcon,
      handleOnClick: () => {
        navigate('/admin/home');
      },
      pathname: '/admin/home',
    },
    ...checkUserRole('users') || checkUserRole('roles') || checkUserRole('end-users') ? [{
      text: t('user_management'),
      icon: MedicalCard,
      menuItems: [
        ...checkUserRole('roles') ? [{
          text: t('role_groups'),
          handleOnClick: () => {
            navigate('/admin/roles');
          },
          pathname: '/admin/roles',
          parentName: t('user_management'), // Custom tag to identify parent
        }] : [],
        ...checkUserRole('users') ? [{
          text: t('admin_users'),
          handleOnClick: () => {
            navigate('/admin/users');
          },
          pathname: '/admin/users',
          parentName: t('user_management'), // Custom tag to identify parent
        }] : [],
        // {
        //   text: t('end-users'),
        //   handleOnClick: () => {
        //     navigate('/admin/endusers');
        //   },
        //   pathname: '/admin/endusers',
        // },
        ...(checkUserRole('end-users') ? [{
          text: t('External-user Categories'),
          handleOnClick: () => navigate('/admin/categories'),
          pathname: '/admin/categories',
          parentName: t('user_management'), // Custom tag to identify parent
        }] : [])
      ],
    }] : [],
    ...checkUserRole('forms') || checkUserRole('sub-forms') ? [{
      text: t('form_management'),
      icon: Planner,
      menuItems: [
        ...checkUserRole('sub-forms') ? [{
          text: t('Subforms'),
          handleOnClick: () => {
            navigate('/admin/subforms');
          },
          pathname: '/admin/subforms',
          parentName: t('form_management'), // Custom tag to identify parent
        }] : [],
        ...checkUserRole('forms') ? [{
          text: t('forms'),
          handleOnClick: () => {
            navigate('/admin/forms');
          },
          pathname: '/admin/forms',
          parentName: t('form_management'), // Custom tag to identify parent
        }] : [],
      ]
    }] : [],
    ...checkUserRole('workflows') ? [{
      text: t('workflow_management'),
      handleOnClick: () => {
        navigate('/admin/workflows');
      },
      icon: PresentationHierarchyLight,
      pathname: '/admin/workflows',
    }] : [],
    ...checkUserRole('requests') ? [{
      text: t('Requests'),
      handleOnClick: () => {
        navigate('/admin/requests');
      },
      icon: StatusCheck,
      pathname: '/admin/requests',
    }] : [],
    ...checkUserRole('users-logs') || checkUserRole('roles-logs') || checkUserRole('workflows-logs') || checkUserRole('forms-logs') || checkUserRole('sub-forms-logs') || checkUserRole('categories-logs') ?
      [{
        text: t('Audit logs'),
        icon: FileAccountPlan,
        menuItems: [
          // {
          //   text: t('other'),
          //   handleOnClick: () => {
          //     navigate('/admin/logs/other');
          //   },
          //   pathname: '/admin/logs/other',
          // },
          ...checkUserRole('roles-logs') ? [{
            text: t('Role groups'),
            handleOnClick: () => {
              navigate('/admin/logs/roles');
            },
            pathname: '/admin/logs/roles',
            parentName: t('Audit logs'), // Custom tag to identify parent
          }] : [],
          ...checkUserRole('users-logs') ? [{
            text: t('Admin Users'),
            handleOnClick: () => {
              navigate('/admin/logs/users');
            },
            pathname: '/admin/logs/users',
            parentName: t('Audit logs'), // Custom tag to identify parent
          }] : [],
          ...checkUserRole('categories-logs') ? [{
            text: t('Categories'),
            handleOnClick: () => {
              navigate('/admin/logs/categories');
            },
            pathname: '/admin/logs/categories',
            parentName: t('Audit logs'), // Custom tag to identify parent
          }] : [],
          ...checkUserRole('subforms-logs') ? [{
            text: t('Subforms'),
            handleOnClick: () => {
              navigate('/admin/logs/subforms');
            },
            pathname: '/admin/logs/subforms',
            parentName: t('Audit logs'), // Custom tag to identify parent
          }] : [],
          ...checkUserRole('forms-logs') ? [{
            text: t('Forms'),
            handleOnClick: () => {
              navigate('/admin/logs/forms');
            },
            pathname: '/super-admin/logs/forms',
            parentName: t('Audit logs'), // Custom tag to identify parent
          }] : [],
          ...checkUserRole('workflows-logs') ? [{
            text: t('workflows'),
            handleOnClick: () => {
              navigate('/admin/logs/workflows');
            },
            pathname: '/admin/logs/workflows',
            parentName: t('Audit logs'), // Custom tag to identify parent
          }] : [],
        ],
      }] : [],
    ...checkUserRole('notifications') ? [{
      text: t('Notification & Reminders'),
      icon: Bell,
      handleOnClick: () => {
        navigate('/admin/reminders');
      },
      pathname: '/admin/reminders',
    }] : [],
    {
      text: t('Product Details'),
      icon: CardView,
      handleOnClick: () => {
        navigate('/admin/product-details');
      },
      pathname: '/admin/product-details',
    },
    {
      text: t('Manufacturers Site'),
      icon: Hotel,
      handleOnClick: () => {
        navigate('/admin/manufacturers-site');
      },
      pathname: '/admin/manufacturers-site',
    },
    // {
    //   text: i18n.language === 'en' ? 'عربي' : 'English',
    //   icon: HouseIcon,
    //   handleOnClick: () => {
    //     toggleLanguage();
    //   }
    // },
    // {
    //   text: t('sign_out'),
    //   icon: HouseIcon,
    //   handleOnClick: handleLogout,
    // },
    {
      text: t('sign_out'),
      icon: ChevronLeft2,
      href: '/login',
      handleOnClick: () => { logout(); navigate('/login'); },
    }
  ];


  return (
    <SidebarCustom
      isSidebarCollapsed={props.isSidebarCollapsed}
      setIsSidebarCollapsed={props.setIsSidebarCollapsed}
      menuItems={menuItems}
    />
  );
}

export default Sidebar;